import { ipApi } from './ip.api';
import { IpRoute } from './ip.route';

export const requestIpData = async (): Promise<unknown> =>
  ipApi.get(IpRoute.IpFullData()).then((res) => res);
